import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import EmployeeLeaveList from "./EmployeeLeaveList";
import CreateNewEmployeeLeave from "./CreateNewEmployeeLeave";
import Excelldownload from "./Excelldownload";
import PdfDownload from "./PdfDownload";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import moment from "moment";

const Maincontent = ({ auth }) => {
  const [updatelist, setUpdatelist] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(false); // New state for data loading
  const componentRef = useRef();

  useEffect(() => {
    if (auth && auth.permissions) {
      setLoading(false);
    }
  }, [auth]);

  if (loading) {
    return (
      <div className="site-layout-background main-frame" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px' 
      }}>
        <Spin size="large" tip="Loading employee leave data..." />
      </div>
    );
  }

  return (
    <>
      <div className="site-layout-background main-frame">
        {dataLoading && ( // Show spinner when data is loading
          <div style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            backgroundColor: 'rgba(255, 255, 255, 0.7)', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            zIndex: 9999 
          }}>
            <Spin size="large" tip="Loading data..." />
          </div>
        )}
        
        {auth.permissions.includes("HRM.Employee Leave_is_create") ? (
          <CreateNewEmployeeLeave
            setUpdatelist={setUpdatelist}
            updatelist={updatelist}
            setLoading={setDataLoading} // Use setDataLoading instead of setLoading
          />
        ) : (
          ""
        )}

        <EmployeeLeaveList
          updatelist={updatelist}
          setUpdatelist={setUpdatelist}
          setData={setData}
          setLoading={setDataLoading} // Use setDataLoading instead of setLoading
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Maincontent);